/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {McpLimitLogsPage} from '../models/McpLimitLogsPage';
import type {McpLimitPageRequest} from '../models/McpLimitPageRequest';

export interface GetMcpLimitLog$Request {
    accountId: number;
    mcpLimitPageRequest: McpLimitPageRequest;
}

export interface GetMcpLimitLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMcpLimitLogRequest = createAction<PayloadData<void, GetMcpLimitLog$Request>>('MCP_LIMIT_LOG__GET_MCP_LIMIT_LOG__REQUEST');
export const getMcpLimitLogSuccess = createAction<PayloadData<McpLimitLogsPage, GetMcpLimitLog$Request>>('MCP_LIMIT_LOG__GET_MCP_LIMIT_LOG__SUCCESS');
export const getMcpLimitLogFailure = createAction<PayloadData<Error, GetMcpLimitLog$Request, true>>('MCP_LIMIT_LOG__GET_MCP_LIMIT_LOG__FAILURE');

export const getMcpLimitLogActions = [
    getMcpLimitLogRequest,
    getMcpLimitLogSuccess,
    getMcpLimitLogFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {McpLimitPageRequest} meta.mcpLimitPageRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMcpLimitLog = (meta: GetMcpLimitLog$Request, config?: GetMcpLimitLog$Config) => {
    return {
        CALL_API: {
            types: getMcpLimitLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/change-logs/mcp/limits`,
            TRANSPORT_REQUEST_BODY: meta.mcpLimitPageRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

